import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { PicklistApi } from '../../sdk/services/custom';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from "lodash";

/*
This custom field is used to select global picklists for an app.
*/

@Component({
  selector: 'formly-picklist-selector',
  template: `
   <ng-select *ngIf="items.length > 0"   
              [active]="selectedvalues"
              (data)="refreshValue($event)"
              (selected)="selected($event)"
              (removed)="removed($event)"
              [items]="items"
              [multiple]="to.multiple"
               [disabled]="to.disabled"
              placeholder=""
              [allowClear]="!to.required" >
  </ng-select>
  `, styleUrls: ['./ng2select.scss'],
  providers: [PicklistApi]
})
export class PicklistSelect extends FieldType implements OnInit, OnDestroy {
  _loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
  items: any = [];
  selectedvalues: any = [];
  constructor(private _PicklistApi: PicklistApi) {
    super();

  }

  ngOnInit() {
    if (!this.form['subscriptions'])
      this.form['subscriptions'] = [];

    // Adding new Controls to hold formControls for hidden fields
    if (!this.form['newcontrols'])
      this.form['newcontrols'] = {};
    for (var key in this.form.controls) {
      this.form['newcontrols'][key] = this.form.controls[key];
    }

    if (this.to["multiple"]) {
      this.to["multiple"] = true;
    } else {
      this.to["multiple"] = false;
    }
    //1) Load the drop down values    
    this._loopbackfilter.where = { 'appId': this.model.appId };
    //Hack - Get the app id from the model itself.
    //Get the picklists for the App
    this._PicklistApi.find(this._loopbackfilter).subscribe((picklists) => {
      if (picklists) {

        for (var i = 0; i < picklists.length; i++) {
          if (this.model.id !== picklists[i]["id"]) {
            this.items.push({ id: picklists[i]["id"], text: picklists[i]["label"] })
          }

          if (this.model[this.key] && this.model[this.key].indexOf(picklists[i]["id"]) > -1) {
            if (this.to["multiple"]) {
              this.selectedvalues.push({ id: picklists[i]["id"], text: picklists[i]["label"] });
            } else {
              this.selectedvalues = [{ id: picklists[i]["id"], text: picklists[i]["label"] }];
            }
          }
        }
        //Sort the values
        this.items = _.sortBy(this.items, 'text');
      }
    });

  }

  ngOnDestroy() {
    if (this.to["multiple"]) {
      this.selectedvalues = [];
    } else {
      this.selectedvalues = "";
    }
  }

  private value: any = {};


  public selected(value: any): void {
    /*
    Push the selected value to the model
    */
    if (this.model[this.key] && this.model[this.key].length) {
      this.model[this.key].push(value.id);
    } else {
      this.model[this.key] = [value.id];
    }
    for (var key in this.form['newcontrols'])
      this.form.setControl(key, this.form['newcontrols'][key]);

  }

  public removed(value: any): void {

    /*
   Remove the removed value to the model
   */
    if (this.model[this.key] && this.model[this.key].length) {
      this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
    }
  }

  public typed(value: any): void {

  }

  public refreshValue(value: any): void {
    this.value = value;
  }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectpicklist.ts